import React from 'react';
import { Font, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

import Roboto from '@assets/roboto/Roboto-Regular.ttf';
import RobotoBold from '@assets/roboto/Roboto-Bold.ttf';

import PdfBody from './pdf-body';

Font.register({
    family: 'Roboto',
    fonts: [{ src: Roboto }, { src: RobotoBold, fontWeight: 600 }],
    format: 'truetype',
});

// Create styles
const styles = StyleSheet.create({
    page: {
        fontFamily: 'Roboto',
        //backgroundColor: '#d11fb6',
        color: 'black',
        padding: 21,
    },
    header: {
        fontSize: 12,
        //  bold: true,
        textAlign: 'center',
    },
    table: {
        fontSize: 5,
        //bold: true,
        margin: 10,
        marginTop: -30,
        textAlign: 'center',
    },
});

const RemainingsPdf = ({ ...props }) => {
    const { remainings } = props;

    return (
        <Document>
            <Page size='A4' style={styles.page} orientation={'portrait'}>
                <View style={styles.header}>
                    <Text>Остатки товаров на складах</Text>
                </View>
                <View style={styles.table}>
                    <PdfBody remainings={remainings} />
                </View>
            </Page>
        </Document>
    );
};
export default RemainingsPdf;
